import React from 'react'
import { useIntl } from 'react-intl';
import { Link } from '@reach/router';
import useNavigateLink from "@/hooks/useNavigateLink";
import getCountry from '@/utils/getCountry.js'
import style from './index.module.less'
import GlobalLangList from '../GlobalLangList';

const PrivacyGlobal = ({pChangeFooterZIndex}) => {
  const country = getCountry()
  const intl = useIntl()
  const navigateLink = useNavigateLink;
  const getLinkUrl = (link) => {
    const url = navigateLink(link)
    return url
  }
  const link_arr=[
    {
      name: intl.formatMessage({ id: "terms_of_service" }),
      link: "/terms-of-service"
    },{
      name: intl.formatMessage({ id: "privacy_policy" }),
      link: "/privacy-policy"
    },{
      name: intl.formatMessage({ id: "return_and_refund_policy" }),
      link: "/return-refund-policy"
    }
  ]

  const maskSetZIndex = (bool) => {
    pChangeFooterZIndex(bool)
  }


  return (
    <div className={style.privacyGlobal}>
      <div className={style.privacy}>
        <span className={style.privacyRights}>
        © XREAL, Inc. All Rights Reserved.
        </span>
        <span className={style.privacyPolicy}>
            {link_arr.map(item=>(
                <Link className={style.policyItem} to={getLinkUrl(item.link)} key={`footerMessageLink-${item.name}`}
                >
                  {item.name}
                </Link>
            ))}
        </span>
      </div>

      <GlobalLangList  country={country} gMaskSetZIndex={maskSetZIndex}/>
    </div>
  )
}

export default PrivacyGlobal
